export default "__VITE_ASSET__DgzPkNVY__"